module.exports = __webpack_public_path__ + "img/5000dou.6576e98b.png";